<template>
    <div class="login">
        <aside class="auth-brand">
            <div class="auth-logo">
                <img src="@/assets/login-showcase/brand-logo.png" width="207" height="51" alt="绿数花旅" />
            </div>
            <div class="auth-brand-copy">
                <div class="auth-intro">
                    <h1>让每一次创作，都有作品可见。</h1>
                    <p>集成花艺、园艺、环境、婚庆等虚拟仿真设计。</p>
                </div>
                <div class="showcase-tabs" role="tablist" aria-label="作品分类">
                    <button
                        v-for="(item, index) in showcases"
                        :key="item.key"
                        type="button"
                        role="tab"
                        :aria-selected="showcaseIndex === index ? 'true' : 'false'"
                        :class="{ active: showcaseIndex === index }"
                        @click="selectShowcase(index)"
                    >
                        <span>0{{ index + 1 }}</span>{{ item.name }}
                    </button>
                </div>
                <transition name="showcase-fade" mode="out-in">
                    <section class="showcase-stage" :key="activeShowcase.key">
                        <header>
                            <div><strong>{{ activeShowcase.name }}</strong><span>{{ activeShowcase.subtitle }}</span></div>
                            <span class="showcase-count">0{{ showcaseIndex + 1 }} / 04</span>
                        </header>
                        <div v-if="activeShowcase.layout === 'flower'" class="showcase-media flower-collage">
                            <figure v-for="image in activeShowcase.images" :key="image.src">
                                <img :src="image.src" :alt="image.label" />
                                <figcaption>{{ image.label }}</figcaption>
                            </figure>
                        </div>
                        <div v-else-if="activeShowcase.layout === 'compare'" class="showcase-media compare-grid">
                            <figure v-for="image in activeShowcase.images" :key="image.src">
                                <img :src="image.src" :alt="image.label" />
                                <figcaption>{{ image.label }}</figcaption>
                            </figure>
                        </div>
                        <div v-else class="showcase-media single-work">
                            <figure>
                                <img :src="activeShowcase.images[0].src" :alt="activeShowcase.images[0].label" />
                                <figcaption>{{ activeShowcase.images[0].label }}</figcaption>
                            </figure>
                        </div>
                    </section>
                </transition>
            </div>
            <div class="auth-copyright">© 福州绿数花旅网络科技有限公司</div>
        </aside>
        <div class="top_bar">
            <div>
                <img src="https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/plat/login/login-zp.png" />

                <div class="ls_flex_center">
                    <img class="w51 h51 mr10" src="https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/official/call.png" />
                    <div>
                        <div class="fz16" style="font-weight: bold">获取帮助</div>
                        <div class="mt6">
                            电话：136 3527 5043
                            <span class="ml20">微信：451697645</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="ls_flex_center">
                <img src="https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/official/shouye-2.png" />
                <div class="login_bk">
                    <h2>欢迎回来</h2><p class="auth-subtitle">登录绿数花旅创作与教学中心</p>
                    <div class="auth-tabs" v-if="type === 'scan'"><button type="button" :class="{ active: authMode === 'scan' }" @click="switchAuthMode('scan')">微信扫码</button><button type="button" :class="{ active: authMode === 'password' }" @click="switchAuthMode('password')">手机号密码</button></div>
                    <div class="type_1" v-if="type === 'scan'" v-show="authMode === 'scan'">
                        <div id="qrcode" ref="qrcode"></div>
                        <h3>微信扫码登录</h3><p>打开微信扫一扫，安全进入工作台</p>
                    </div>
                    <div class="password-form" v-if="type === 'scan' && authMode === 'password'">
                        <label>手机号<el-input v-model.trim="passwordInfo.phone" maxlength="11" placeholder="请输入手机号"></el-input></label>
                        <label>密码<el-input v-model="passwordInfo.password" :type="showPassword ? 'text' : 'password'" maxlength="32" placeholder="请输入密码" @keyup.enter.native="passwordLogin"><button type="button" slot="suffix" class="show-password" @click="showPassword = !showPassword">{{ showPassword ? '隐藏' : '显示' }}</button></el-input></label>
                        <div class="guard-box" :class="{ ready: passwordChallenge.challengeId }">
                            <button v-if="!passwordChallenge.challengeId" type="button" class="guard-button" @click="getPasswordChallenge">点击获取安全验证</button>
                            <template v-else>
                                <span class="guard-question">{{ passwordChallenge.question }}</span>
                                <el-input v-model.trim="passwordChallenge.answer" maxlength="2" placeholder="答案" @keyup.enter.native="passwordLogin"></el-input>
                                <button type="button" class="guard-refresh" @click="getPasswordChallenge">换一题</button>
                            </template>
                        </div>
                        <button type="button" class="password-submit" :disabled="passwordLoading" @click="passwordLogin">{{ passwordLoading ? '登录中…' : '登录' }}</button>
                        <p class="password-note">仅已绑定手机号的用户可使用密码登录；登录后可在账号管理中修改密码。</p>
                    </div>
                    <div class="type_2" v-if="type === 'info'">
                        <div>填写信息完成注册</div>
                        <div>准确填写信息，让我们更好的为您匹配体验功</div>
                        <el-form label-width="90px">
                            <el-form-item label="手机号">
                                <el-input v-model="info.phone" maxlength="11"></el-input>
                            </el-form-item>
                            <el-form-item label="验证码">
                                <el-input v-model="info.code" maxlength="4">
                                    <template slot="append">
                                        <div class="code_btn" @click="getCode">
                                            {{ cutdown ? cutdown + "s" : "获取验证码" }}
                                        </div>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="您的身份">
                                <el-select v-model="info.identity" placeholder="请选择">
                                    <el-option label="学校老师" value="学校老师"></el-option>
                                    <el-option label="培训机构" value="培训机构"></el-option>
                                    <el-option label="学生" value="学生"></el-option>
                                    <el-option label="插花爱好者" value="插花爱好者"></el-option>
                                    <el-option label="插花师" value="插花师"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="想解决问题">
                                <el-select v-model="info.question" placeholder="请选择">
                                    <el-option label="想要教学课件" value="想要教学课件"></el-option>
                                    <el-option label="找数字插花作品" value="找数字插花作品"></el-option>
                                    <el-option label="办插花比赛" value="办插花比赛"></el-option>
                                    <el-option label="数字化虚拟插花解决方案" value="数字化虚拟插花解决方案"></el-option>
                                    <el-option label="节省花材损耗" value="节省花材损耗"></el-option>
                                    <el-option label="其他" value="其他"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="login_btn" @click="login">登录</div>
                        </el-form>
                    </div>
                    <div class="type_3" v-if="type === 'choose'">
                        <div>您可以使用以下账户</div>
                        <div>您已绑定多个账户，当前可选择一个账户登录，之后也能 进行切换。</div>
                        <div class="school_list">
                            <div v-for="item in schoolList" :key="item.organizationId" @click="change(item)">
                                {{ item.organizationName }}
                            </div>
                        </div>
                    </div>
                    <div class="login_bk_tip">
                        登录即视为您同意我们的
                        <a href="https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/static/%E7%BB%BF%E6%95%B0%E8%8A%B1%E6%97%85_%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.docx">《隐私政策》</a>
                        和
                        <a href="https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/static/%E7%BB%BF%E6%95%B0%E8%8A%B1%E6%97%85_%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.docx">《服务条款》</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_bar">
            <div>
                <div class="beian">
                    © 2023,©福州绿数花旅网络科技有限公司 版权所有 备案号：
                    <a href="https://beian.miit.gov.cn" target="_blank">
                        <img src="https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/static/beian.png" />
                        闽ICP备2023001658号
                    </a>
                    <br />
                    <!-- 地址：福州市高新区XXXXX -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
    data() {
        return {
            qrcodeItem: "",
            authMode: 'scan',
            passwordInfo: { phone: '', password: '' },
            passwordChallenge: { challengeId: '', question: '', answer: '' },
            passwordLoading: false,
            showPassword: false,
            info: {
                phone: "",
                code: "",
                identity: "学校老师",
                question: "想要教学课件",
            },
            cutdown: 0,
            sceneStr: "",
            tId: "",
            scanTimer: null,
            showcaseTimer: null,
            showcaseIndex: 0,
            showcases: [
                {
                    key: 'flower',
                    name: '插花作品',
                    subtitle: '数字插花·中式意境作品选',
                    layout: 'flower',
                    images: [
                        { src: require('@/assets/login-showcase/flower-xu.jpg'), label: '徐铭璐同学作品' },
                        { src: require('@/assets/login-showcase/flower-huang.jpg'), label: '黄云玲教授作品' },
                        { src: require('@/assets/login-showcase/flower-chen.jpg'), label: '陈玉霞作品' },
                    ],
                },
                {
                    key: 'modern',
                    name: '现代花艺',
                    subtitle: '人体花艺·立体构成练习',
                    layout: 'single',
                    images: [{ src: require('@/assets/login-showcase/modern-floral.jpg'), label: '人体花艺作品' }],
                },
                {
                    key: 'environment',
                    name: '花艺环境',
                    subtitle: '从空间底图到完整花艺场景',
                    layout: 'compare',
                    images: [
                        { src: require('@/assets/login-showcase/environment-before.jpg'), label: '空白场景' },
                        { src: require('@/assets/login-showcase/environment-after.jpg'), label: '花艺设计效果' },
                    ],
                },
                {
                    key: 'garden',
                    name: '园林景观',
                    subtitle: '庭院场景的绿化与景观表达',
                    layout: 'compare',
                    images: [
                        { src: require('@/assets/login-showcase/garden-before.jpg'), label: '空白庭院' },
                        { src: require('@/assets/login-showcase/garden-after.jpg'), label: '园林景观效果' },
                    ],
                },
            ],
            type: "scan",
            schoolList: [],
        };
    },
    computed: {
        activeShowcase() {
            return this.showcases[this.showcaseIndex];
        },
    },
    methods: {
        selectShowcase(index) {
            this.showcaseIndex = index;
            this.startShowcaseTimer();
        },
        startShowcaseTimer() {
            if (this.showcaseTimer) window.clearInterval(this.showcaseTimer);
            this.showcaseTimer = window.setInterval(() => {
                this.showcaseIndex = (this.showcaseIndex + 1) % this.showcases.length;
            }, 5200);
        },
        switchAuthMode(mode) {
            this.authMode = mode;
            if (this.scanTimer) {
                window.clearTimeout(this.scanTimer);
                this.scanTimer = null;
            }
            if (mode === 'password' && !this.passwordChallenge.challengeId) {
                this.getPasswordChallenge();
            }
            if (mode === 'scan' && this.sceneStr) {
                this.waitScan();
            }
        },
        getPasswordChallenge() {
            this.passwordChallenge = { challengeId: '', question: '', answer: '' };
            return this.$ajax.get('/login/password/challenge').then(res => {
                this.passwordChallenge = {
                    challengeId: res.data.challengeId,
                    question: res.data.question,
                    answer: '',
                };
            });
        },
        passwordLogin() {
            if (!/^1\d{10}$/.test(this.passwordInfo.phone)) return this.$message.warning('请输入正确的手机号');
            if (!this.passwordInfo.password) return this.$message.warning('请输入密码');
            if (!this.passwordChallenge.challengeId || !this.passwordChallenge.answer) return this.$message.warning('请完成安全验证');
            if (this.passwordLoading) return;

            this.passwordLoading = true;
            this.$ajax.post('/login/password', {
                phone: this.passwordInfo.phone,
                password: this.passwordInfo.password,
                challengeId: this.passwordChallenge.challengeId,
                challengeAnswer: this.passwordChallenge.answer,
            }).then(res => {
                localStorage.setItem('authToken', res.data);
                if (this.scanTimer) window.clearTimeout(this.scanTimer);
                this.$message.success('登录成功');
                setTimeout(this.getSchoolList, 200);
            }).catch(() => {
                this.getPasswordChallenge();
            }).finally(() => {
                this.passwordLoading = false;
            });
        },
        change(item) {
            this.$ajax
                .post("/user/user/changeOrganization", {
                    organizationId: item.organizationId,
                })
                .then(res => {
                    window.location.href = "./";
                });
        },
        getSchoolList() {
            this.$ajax.post("user/user/getOrganizationList", {}).then(res => {
                this.schoolList = res.data || [];

                let cur =
                    this.schoolList.find(item => {
                        return item.isCurrent == 1;
                    }) || {};

                localStorage.setItem("currentSchool", JSON.stringify(cur));
                if (this.schoolList.length === 1) {
                    window.location.href = "/";
                } else if (this.schoolList.length > 1) {
                    this.type = 'choose';
                }
            });
        },
        //获取验证码
        getCode() {
            if (!/^1\d{10}$/.test(this.info.phone)) {
                this.$message({
                    message: "请输入正确的手机号",
                    type: "warning",
                });
                return;
            }
            if (this.cutdown) {
                return;
            }
            this.cutdown = 60;
            this.$ajax.post("/login/sms/send", {
                phone: this.info.phone,
                smsType: "REGISTER",
            });
            let tId = setInterval(() => {
                this.cutdown--;
                if (!this.cutdown) {
                    clearInterval(tId);
                }
            }, 1000);
        },
        //登录
        login() {
            if (!/^1\d{10}$/.test(this.info.phone)) {
                this.$message({
                    message: "请输入正确的手机号",
                    type: "warning",
                });
                return;
            }
            if (!/^\d{4}$/.test(this.info.code)) {
                this.$message({
                    message: "请输入正确的验证码",
                    type: "warning",
                });
                return;
            }

            this.$ajax
                .post("/login/login", {
                    type: this.sceneStr ? "1" : "0",
                    loginSercet: this.sceneStr,
                    phone: this.info.phone,
                    smsCode: this.info.code,
                    job: 10001,
                    question: this.info.question,
                })
                .then(res => {
                    if (res.code == 200) {
                        localStorage.setItem("authToken", res.data);
                        setTimeout(this.getSchoolList, 200);
                    }
                });
        },
        // 获取登录二维码
        getScanCode() {
            this.$ajax.post("login/qrcode/getWechat").then(res => {
                this.qrcodeItem = new QRCode("qrcode", {
                    width: 214, // 设置宽度，单位像素
                    height: 214, // 设置高度，单位像素
                    text: res.data.url, // 设置二维码内容或跳转地址
                });
                this.qrcodeItem._el.title = "";
                this.sceneStr = res.data.loginSercet;
                this.waitScan();
            });
        },
        waitScan() {
            if (this.type !== 'scan' || this.authMode !== 'scan') return;
            this.$ajax.post("/login/scanResult/" + this.sceneStr).then(res => {
                switch (res.data.result) {
                    // 待扫码
                    case 0:
                        this.scanTimer = setTimeout(() => {
                            this.waitScan();
                        }, 2000);
                        break;
                    case 1:
                        // 已扫码未注册
                        this.qrcodeItem.clear();
                        window.clearInterval(this.tId);
                        this.type = "info";
                        break;
                    case 2:
                        // 已扫码已注册
                        this.$refs.qrcode.innerHTML = "";
                        window.clearInterval(this.tId);
                        this.type = "choose";
                        this.$message({
                            message: "扫码成功",
                            type: "success",
                        });
                        this.$ajax
                            .post("/login/login", {
                                type: this.sceneStr ? "1" : "0",
                                loginSercet: this.sceneStr,
                            })
                            .then(res => {
                                if (res.code == 200) {
                                    console.log(res.data);
                                    localStorage.setItem("authToken", res.data);

                                    setTimeout(this.getSchoolList, 200);
                                }
                            });
                        break;
                    default:
                        this.$message({
                            message: res.msg || '扫码登录失败，请刷新重试',
                            type: "error",
                        });
                }
            });
        },
    },
    mounted() {
        this.getScanCode();
        this.startShowcaseTimer();
    },
    beforeDestroy() {
        if (this.scanTimer) window.clearTimeout(this.scanTimer);
        if (this.showcaseTimer) window.clearInterval(this.showcaseTimer);
    },
};
</script>
<style>
.login .el-select {
    width: 282px;
}
</style>
<style lang="scss" scoped>
.beian {
    font-size: 12px;
    color: #7c93ad;
    line-height: 20px;
    text-align: center;
}
.bottom_bar {
    padding: 10px 0 16px 0;
    background-color: #f5f7fa;
    > div {
        width: 750px;
        margin: 0 auto;
    }
    .ls_flex {
        > * {
            font-size: 14;
            color: #565656;
            line-height: 40px;
            + * {
                margin-left: 80px;
            }
        }
    }
}
.school_list {
    overflow-y: auto;
    flex: 1;
    height: 1px;
    margin-bottom: 20px;

    margin-top: 10px;
    > div {
        line-height: 50px;
        height: 50px;
        font-size: 18px;
        padding-left: 10px;
        cursor: pointer;
        + div {
            border-top: 1px solid #eee;
        }
        &:hover {
            background: #eee;
        }
    }
}
.code_btn {
    cursor: pointer;
    width: 70px;
    text-align: center;
}
.login_btn {
    width: 372px;
    line-height: 50px;
    background: #ffc928;
    text-align: center;
    color: #fff;
    font-size: 18px;
    border-radius: 25px;
    cursor: pointer;
}
.type_2 {
    padding: 20px 30px 0 30px;
    > div {
        &:nth-child(1) {
            font-size: 26px;
            line-height: 37px;
        }
        &:nth-child(2) {
            font-size: 14px;
            line-height: 20px;
            color: #999;
            margin-bottom: 15px;
        }
    }
}
.type_1 {
    text-align: center;
    padding-top: 37px;
    > div {
        &:nth-child(1) {
            font-size: 32px;
            line-height: 45px;
        }
        &:nth-child(2) {
            font-size: 14px;
            line-height: 20px;
            color: #999;
            position: relative;
            &:before,
            &:after {
                content: "";
                position: absolute;
                width: 28px;
                height: 1px;
                background: #e9e9e9;
                top: 10px;
            }
            &:before {
                margin-left: -33px;
            }
            &:after {
                margin-left: 5px;
            }
        }
        &:nth-child(3) {
            width: 214px;
            height: 214px;
            border-radius: 8px;
            background: #eeeeee;
            margin-top: 30px;
            margin: 40px auto 40px auto;
        }
    }
}
.login {
    min-height: 100vh;
    min-width: 100vw;
    background: #fff;
    .top_bar {
        height: 140px;
        border-bottom: 1px solid #e9e9e9;
        > div {
            height: 100%;
            width: 1330px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;

            > img {
                height: 64px;
            }
        }
    }
    .main {
        padding: 77px 0;
        border-bottom: 1px solid #e9e9e9;
        .login_bk {
            margin-left: 141px;
            width: 432px;
            height: 432px;
            border-radius: 15px;
            border: 1px solid #e5e5e5;
            position: relative;
            .login_bk_tip {
                position: absolute;
                bottom: 15px;
                line-height: 20px;
                width: 100%;
                text-align: center;
                span {
                    color: #007cd9;
                    cursor: pointer;
                }
            }
        }
    }
}
.type_3 {
    padding: 30px;
    display: flex;
    flex-direction: column;
    height: 372px;

    > div {
        &:nth-child(1) {
            font-size: 26px;
            line-height: 37px;
        }
        &:nth-child(2) {
            font-size: 14px;
            color: #999;
            margin-top: 3px;
            line-height: 20px;
        }
    }
}
.login {
    display: grid;
    grid-template-columns: minmax(420px, 1.08fr) minmax(430px, .92fr);
    min-width: 0;
    background: #f7faf8;
    .top_bar, .bottom_bar { display: none; }
    .main {
        min-width: 0;
        display: grid;
        place-items: center;
        padding: 48px;
        border: 0;
        background: linear-gradient(180deg, #fbfdfc, #f5f9f7);
        > .ls_flex_center { width: 100%; }
        > .ls_flex_center > img { display: none; }
        .login_bk {
            width: min(460px, 100%);
            height: auto;
            min-height: 470px;
            margin: 0;
            padding: 34px;
            border: 1px solid #e3ebe6;
            border-radius: 22px;
            background: #fff;
            box-shadow: 0 22px 54px rgba(35,80,53,.1);
            h2 { color: #18201c; font-size: 28px; font-weight: 700; }
            .auth-subtitle { margin: 9px 0 24px; color: #89948d; font-size: 13px; }
            .login_bk_tip { position: static; margin-top: 22px; color: #96a199; font-size: 12px; line-height: 1.7; }
            .login_bk_tip a { color: #21965b; }
        }
    }
}
.auth-brand {
    position: relative;
    box-sizing: border-box;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    padding: 28px 36px;
    color: #fff;
    background: radial-gradient(circle at 20% 8%, rgba(255,255,255,.2), transparent 27%), linear-gradient(145deg, #158550, #249862 54%, #307f68);
    &::before { content: ""; position: absolute; width: 380px; height: 380px; right: -150px; top: -120px; border: 1px solid rgba(255,255,255,.15); border-radius: 50%; }
}
.auth-logo {
    position: relative;
    z-index: 1;
    align-self: flex-start;
    padding: 9px 14px;
    border: 1px solid rgba(255,255,255,.62);
    border-radius: 14px;
    background: rgba(255,255,255,.96);
    box-shadow: 0 12px 30px rgba(11,69,41,.15);
}
.auth-logo img {
    display: block;
    width: 207px;
    height: 51px;
    max-width: 100%;
    object-fit: contain;
    image-rendering: auto;
}
.auth-brand-copy {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 720px;
    margin: 18px 0;
}
.auth-intro { margin-bottom: 12px; }
.auth-brand h1 { margin: 0 0 8px; font-size: clamp(25px, 2.3vw, 35px); font-weight: 700; line-height: 1.25; }
.auth-brand p { max-width: 620px; color: rgba(255,255,255,.82); font-size: 13px; line-height: 1.65; }
.showcase-tabs {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 7px;
    margin-bottom: 10px;
}
.showcase-tabs button {
    height: 38px;
    padding: 0 10px;
    overflow: hidden;
    border: 1px solid rgba(255,255,255,.23);
    border-radius: 10px;
    color: rgba(255,255,255,.76);
    background: rgba(255,255,255,.09);
    font-size: 12px;
    font-weight: 650;
    white-space: nowrap;
    cursor: pointer;
    transition: border-color .2s, color .2s, background .2s, transform .2s;
}
.showcase-tabs button:hover { transform: translateY(-1px); border-color: rgba(255,255,255,.55); color: #fff; }
.showcase-tabs button.active { border-color: #fff; color: #197d4c; background: #fff; box-shadow: 0 9px 22px rgba(12,76,44,.16); }
.showcase-tabs button span { margin-right: 5px; font-size: 10px; opacity: .7; }
.showcase-stage {
    overflow: hidden;
    padding: 10px;
    border: 1px solid rgba(255,255,255,.3);
    border-radius: 17px;
    background: rgba(255,255,255,.13);
    box-shadow: 0 18px 42px rgba(7,71,39,.14);
    backdrop-filter: blur(10px);
}
.showcase-stage > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 4px 9px;
}
.showcase-stage > header div { min-width: 0; }
.showcase-stage > header strong { display: block; font-size: 15px; line-height: 1.35; }
.showcase-stage > header div span { display: block; margin-top: 2px; overflow: hidden; color: rgba(255,255,255,.72); font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
.showcase-count { flex: 0 0 auto; color: rgba(255,255,255,.68); font-size: 10px; letter-spacing: .1em; }
.showcase-media { height: clamp(300px, 42vh, 420px); }
.showcase-media figure { display: grid; grid-template-rows: minmax(0, 1fr) auto; min-width: 0; min-height: 0; overflow: hidden; margin: 0; border-radius: 11px; background: rgba(9,61,36,.22); }
.showcase-media img { display: block; min-width: 0; min-height: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; image-rendering: auto; }
.showcase-media figcaption {
    justify-self: start;
    box-sizing: border-box;
    max-width: calc(100% - 16px);
    margin: 6px 8px 8px;
    padding: 5px 8px;
    overflow: hidden;
    border: 1px solid rgba(255,255,255,.38);
    border-radius: 999px;
    color: #fff;
    background: rgba(15,43,28,.58);
    box-shadow: 0 4px 12px rgba(0,0,0,.14);
    backdrop-filter: blur(7px);
    font-size: 10px;
    line-height: 1.4;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.flower-collage { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-template-rows: minmax(0, 1fr); gap: 7px; }
.compare-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 7px; }
.single-work figure { width: 100%; height: 100%; }
.showcase-fade-enter-active, .showcase-fade-leave-active { transition: opacity .22s ease, transform .22s ease; }
.showcase-fade-enter, .showcase-fade-leave-to { opacity: 0; transform: translateY(5px); }
.auth-copyright { color: rgba(255,255,255,.65); font-size: 12px; }
.auth-tabs { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; padding: 4px; margin-bottom: 22px; border-radius: 12px; background: #f1f5f2; }
.auth-tabs button { height: 40px; border-radius: 9px; color: #738078; font-size: 14px; font-weight: 650; cursor: pointer; }
.auth-tabs button.active { color: #21965b; background: #fff; box-shadow: 0 5px 15px rgba(31,83,50,.08); }
.type_1 { padding: 0; text-align: center; }
.type_1 #qrcode { width: 214px; height: 214px; margin: 8px auto 20px; padding: 0; border: 1px solid #dce6df; border-radius: 14px; overflow: hidden; background: #fff; }
.type_1 h3 { color: #34413a; font-size: 17px; font-weight: 650; }
.type_1 p { margin-top: 9px; color: #849088; font-size: 13px; }
.password-form label { display: block; margin-bottom: 17px; color: #4a5850; font-size: 13px; font-weight: 650; }
.password-form label .el-input { display: block; margin-top: 8px; }
.show-password { padding: 0 8px; color: #21965b; font-size: 12px; cursor: pointer; }
.guard-box { min-height: 42px; margin: 4px 0 16px; border: 1px solid #dce6df; border-radius: 10px; background: #f8fbf9; box-sizing: border-box; }
.guard-box.ready { display: flex; align-items: center; gap: 10px; padding: 6px 10px 6px 14px; border-color: #bfe3ce; background: #f2fbf6; }
.guard-button { width: 100%; height: 40px; color: #708078; font-size: 13px; cursor: pointer; }
.guard-question { flex: 1; color: #315e45; font-size: 14px; font-weight: 650; }
.guard-box .el-input { width: 78px; }
::v-deep .guard-box .el-input__inner { height: 30px; padding: 0 9px; border-color: #cfe3d6; background: #fff; text-align: center; }
.guard-refresh { flex: 0 0 auto; color: #21965b; font-size: 12px; cursor: pointer; }
.password-submit { width: 100%; height: 46px; border-radius: 11px; color: #fff; background: #21965b; font-size: 15px; font-weight: 700; cursor: pointer; }
.password-submit:disabled { cursor: not-allowed; opacity: .65; }
.password-note { margin-top: 12px; color: #89948d; font-size: 12px; line-height: 1.6; }
.type_2 { padding: 0; }
.type_2 > div:first-child { font-size: 22px; font-weight: 650; }
.type_2 .login_btn { width: 100%; margin-top: 8px; border-radius: 11px; background: #21965b; }
.type_3 { padding: 0; height: auto; }
@media (max-width: 1080px) {
    .auth-brand { padding: 24px; }
    .auth-logo { padding: 7px 11px; }
    .auth-brand h1 { font-size: 25px; }
    .showcase-tabs button { padding: 0 6px; font-size: 11px; }
    .showcase-tabs button span { display: none; }
    .login .main { padding: 28px; }
}
@media (max-width: 900px) {
    .login { grid-template-columns: 1fr; }
    .auth-brand { min-height: auto; padding: 28px; }
    .auth-brand-copy { max-width: none; margin: 26px 0; }
    .showcase-media { height: 360px; }
    .login .main { padding: 28px; }
}
@media (max-width: 560px) {
    .auth-brand { padding: 20px 16px; }
    .auth-logo img { width: 183px; height: auto; }
    .auth-brand h1 { font-size: 23px; }
    .showcase-tabs { grid-template-columns: 1fr 1fr; }
    .showcase-media { height: 360px; }
    .flower-collage { height: 420px; grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; }
    .flower-collage figure:first-child { grid-column: 1 / 3; grid-row: auto; }
    .compare-grid { grid-template-columns: 1fr; grid-template-rows: 1fr 1fr; }
    .login .main { padding: 16px; }
    .login .main .login_bk { padding: 24px; }
}
</style>
